import { ECalendarName } from "motw_core/Calendar/ECalendarName";
import * as React from "react";
import { CalendarEvent } from "source/app/presentation/MainPanel/Calendar/CalendarEventUtils/CalendarEvent";
import { Switch } from "source/app/presentation/MainPanel/Dreams/DreamTools/Switch/Switch";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import { SetEventToDoneAsync } from "./SetEventToDoneAsync";
import { SetEventToNotDoneAsync } from "./SetEventToNotDoneAsync";
import { calendarEvent_freeTime } from "motw_core/Constants/constants";
import { AreEqual } from "source/app/services/Shared/ReactHelpers";
import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";

const CalendarEventDoneSwitch = React.memo(function CalendarEventDoneSwitch({
    eventData,
}: {
    eventData: ICalendarEvent;
}) {
    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    const { isCompleted, matchingGoal, completionEventId } = eventData;

    var calendarEvent = new CalendarEvent(eventData);

    if (
        calendarEvent.BelongsToCalendar(ECalendarName.Free) &&
        eventData.name === calendarEvent_freeTime
    ) {
        return (
            <div
                {...Style(`calendarEventFreeTimeIcon`, {
                    float: "right",
                    fontSize: "22px",
                    right: "10px",
                    position: "relative",
                    top: "2px",
                    opacity: 0.8,
                })}
            >
                <Glyphicon icon={EGlyphicon["question-sign"]} />
            </div>
        );
    }

    return (
        <div {...Style(`floatRight`, { float: `right` })}>
            <Switch
                key={eventData.completionEventId}
                label="○"
                labelRight="✓"
                onChange={async () => {
                    try {
                        setIsSaving(true);

                        return isCompleted
                            ? await SetEventToNotDoneAsync(
                                  calendarEvent.eventData,
                                  completionEventId
                              )
                            : await SetEventToDoneAsync(
                                  calendarEvent,
                                  matchingGoal
                              );
                    } finally {
                        setIsSaving(false);
                    }
                }}
                isChecked={isCompleted}
                displayInline
                backgroundColor={isSaving ? `orange` : "yellowgreen"}
                readonly={isSaving}
                completionEventId={eventData.completionEventId}
            />
        </div>
    );
},
AreEqual);

export { CalendarEventDoneSwitch };
